import { makeStyles } from '@material-ui/core';
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import NavBar from './NavBar';
import { useDispatch, useSelector } from 'react-redux';
import { getDriverForUserQc31, getDriverQc31, getEndUserQc31 } from 'src/features/reportBgtQC31Slice';

const BaoCaoBGTView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const isAdmin =  useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isUser =  useSelector(state => state.authSlice.isUser);
  const agencyId = useSelector(state => state.authSlice.agencyId);
  const userId = useSelector(state => state.authSlice.userId);

  useEffect(() => {
    if(isAdmin){
      dispatch(getEndUserQc31({}));
    }
    if(isAgency && agencyId){
      dispatch(getDriverQc31({id: agencyId}));
    }
    if(isUser && userId){
      dispatch(getDriverForUserQc31({id: userId}))
    }
  }, [isAdmin, isAgency, isUser, agencyId, userId]);

  return (
    <div className={classes.root}>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <Outlet />
            </div>
          </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    marginTop: '17px',
    marginLeft: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 280
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  },
  option: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center'
  }
}));


export default BaoCaoBGTView;
